export const environment = {
  production: true,
  env: "prod",
  apiHost: "https://production.zceppa.com/",
  adminApiHost: "https://adminproduction.zceppa.com/",
  widgetDomain: "https://widget.zceppa.com/",
  spritePath: "assets/sprites/sprite.svg",
  fbAppId: "2262024527378539",
  pusher: {
    key: "e25692894f683359a2ae",
    cluster: "ap2",
  }
};
